import { IoIosAddCircle } from "react-icons/io";
import FileUploaderForPart from "../dashboard/FileUploaderForPart";
import { useDisclosure } from "@chakra-ui/hooks";
import { Button } from "@chakra-ui/button";
import { useEffect, useState } from "react";
import { Container, Flex, Text } from "@chakra-ui/react";
import { RiSubtractFill } from "react-icons/ri";
import DeletePartDialog from "./dialogs/confirm/DeletePartDialog";
import videosConstants from "../../../constants/VideosConstants";

const MAX_FILES = videosConstants.MAX_FILES;

export default function PartsList({
  project,
  t,
  activePart,
  setActivePart,
  setPart,
  appNewPart,
  removePartById,
  language,
  setPreviewLoaderFlag,
  setProject,
}) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [parts, setParts] = useState(project.parts);

  useEffect(() => {
    const realParts = project?.parts || [];
    const emptySlots = Array(MAX_FILES).fill({});
    setParts([
      ...realParts,
      ...emptySlots.slice(0, MAX_FILES - realParts.length),
    ]);
  }, [project.parts]);

  const [partSelectedToDeleteId, setPartSelectedToDeleteId] = useState(null);
  const {
    isOpen: removePartDialogIsOpen,
    onOpen: removePartDialogOnOpen,
    onClose: removePartDialogOnClose,
  } = useDisclosure();

  const handleActivePart = (ele) => {
    setPreviewLoaderFlag(true);
    const newPart = { ...ele };
    setActivePart(ele.id);
    setPart(newPart);
  };

  function removePart(partId) {
    setPartSelectedToDeleteId(partId);
    removePartDialogOnOpen();
  }

  return (
    <>
      <DeletePartDialog
        language={language}
        isOpen={removePartDialogIsOpen}
        onClose={removePartDialogOnClose}
        partSelectedToDeleteId={partSelectedToDeleteId}
        setActivePart={setActivePart}
        removePartById={removePartById}
        setParts={setParts}
      />

      <FileUploaderForPart
        projectId={project.id}
        isOpen={isOpen}
        onClose={onClose}
        appNewPart={appNewPart}
        setProject={setProject}
      />

      <div className='m-2'>
        <Flex align={"center"}>
          <p className='w-32 text-lg'>{t("building.videos")}</p>
        </Flex>
        <div className='flex flex-row gap-5 mx-[0.5rem] mt-4'>
          {parts.map((ele, index) => {
            return Object.keys(ele).length ? (
              <div key={ele.id} className='justify-center items-center'>
                <div
                  key={index}
                  className={`h-32 w-20 ${
                    activePart === ele.id
                      ? "border-4 border-[#00c0f3]"
                      : "border border-black"
                  } rounded-lg relative`}
                >
                  <RiSubtractFill
                    onClick={() => {
                      removePart(ele.id);
                    }}
                    className='absolute -left-3 -top-3 text-white bg-primary rounded-sm w-4 h-4 border border-black cursor-pointer'
                  />

                  <Container
                    backgroundImage={ele.part_img}
                    w='full'
                    h='full'
                    backgroundSize='cover'
                    backgroundRepeat='no-repeat'
                    backgroundPosition='center'
                    backgroundColor='#00bcee'
                    borderRadius={activePart === ele.id ? "0" : "8px"}
                    onClick={() => handleActivePart(ele)}
                    cursor='pointer'
                  />
                </div>
                <p className='text-center text-gray-500 text-sm'>{++index}</p>
              </div>
            ) : (
              <div
                onClick={onOpen}
                key={index}
                className='h-32 w-20 border-2 border-dashed border-[#00c0f3] rounded-lg relative flex items-center justify-center cursor-pointer hover:opacity-80'
              >
                <IoIosAddCircle className='text-2xl text-primary' />
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
